export const normalizeExternalOrder = (o) => {
  const hotel = o.hotel?.included ? o.hotel : null
  const transport = o.transport ?? {}

  return {
    id: String(o.order ?? o.id ?? ""),
    status: o.status ?? "",
    createDate: o.create_date ?? "",
    hotel: hotel?.hotel_name ?? "—",
    country: hotel?.country ?? "",
    region: hotel?.region_name ?? "",
    nights: hotel?.nights ?? "",
    fromDate: hotel?.from_date ?? o.insurance?.from_date ?? "",
    toDate: hotel?.to_date ?? o.insurance?.to_date ?? "",
    room: hotel?.room ?? "",
    board: hotel?.board ?? "",
    category: hotel?.category ? `${hotel.category}*` : "",
    clientCost: o.costs_in_currency?.client_cost ?? o.costs?.client_cost ?? "",
    currency: o.costs_in_currency?.currency ?? o.valute ?? "EUR",
    customers: (o.customers ?? []).map((c) => ({
      name: `${c.name} ${c.surname}`.trim(),
      passport: c.passport ?? "",
      dob: c.dob ?? "",
    })),
    insurance: o.insurance?.included ?? false,
    transfer: o.transfer?.included ?? false,
    transport: (transport.included_depart || transport.included_retur) ?? false,
  }
}

export const getOrderId = (o) => String(o.order ?? o.id ?? "")
export const getOrderStatus = (o) => o.status ?? ""
export const getOrderCreateDate = (o) => o.create_date ?? ""

export const getHotel = (o) => (o.hotel?.included ? o.hotel : null)
export const getHotelName = (o) => getHotel(o)?.hotel_name ?? "—"
export const getHotelCountry = (o) => getHotel(o)?.country ?? ""
export const getHotelRegion = (o) => getHotel(o)?.region_name ?? ""
export const getHotelNights = (o) => getHotel(o)?.nights ?? ""
export const getHotelRoom = (o) => getHotel(o)?.room ?? ""
export const getHotelBoard = (o) => getHotel(o)?.board ?? ""
export const getHotelCategory = (o) => {
  const c = getHotel(o)?.category
  return c ? `${c}*` : ""
}

export const getFromDate = (o) => getHotel(o)?.from_date ?? o.insurance?.from_date ?? ""
export const getToDate = (o) => getHotel(o)?.to_date ?? o.insurance?.to_date ?? ""

export const getClientCost = (o) => o.costs_in_currency?.client_cost ?? o.costs?.client_cost ?? ""
export const getCurrency = (o) => o.costs_in_currency?.currency ?? o.valute ?? "EUR"

export const getCustomers = (o) =>
  (o.customers ?? []).map((c) => ({
    name: `${c.name} ${c.surname}`.trim(),
    passport: c.passport ?? "",
    dob: c.dob ?? "",
  }))

export const hasInsurance = (o) => o.insurance?.included ?? false
export const hasTransfer = (o) => o.transfer?.included ?? false
export const hasTransport = (o) =>
  (o.transport?.included_depart || o.transport?.included_retur) ?? false
